<script>
    import DataFetcher from '~/components/DataFetcher.svelte';
    import Article from '~/components/Article.svelte';
    import Spinner from '~/components/Spinner.svelte';

    import InfiniteScroll from "svelte-infinite-scroll";
    
    export let title = '';
    export let category = null;
    export let tags = [];
    
    $: where = [
        ...category ? [['category', '==', category]] : [],
        ...tags.length > 0 ? [['tags', 'contains-any', tags]] : []
    ];
</script>

<style lang="scss">
    .translucent {
        opacity: 0.5;
    }
</style>

<svelte:head>
    <title>Nan Dake{title ? ` - ${title}` : ''}</title>
</svelte:head>

{#if title && title.length}
    <h2>{title}</h2>
{/if}

<DataFetcher collection="posts" {where} let:item>
    <div class:translucent={!item.visible}>
        <Article
            title={item.title}
            tags={item.tags}
            date={item.timestamp}
            url="/post/{item.__meta__.id}"
            contents={item.contents}
            files={item.files}
            category={item.category}
        />
    </div>
</DataFetcher>
